module.exports = __webpack_public_path__ + "static/media/icon-supplies-alcohol.a922fe60.svg";